import {Directive, ElementRef, HostListener, Input,Component, OnInit, ViewChild } from '@angular/core';
import {UntypedFormBuilder,ValidationErrors, UntypedFormGroup, Validators,AbstractControl} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {MatSnackBar} from '@angular/material/snack-bar';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router,ActivatedRoute } from '@angular/router';
import {Servicio} from '../servicio/servicio';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-registrar',
  templateUrl: './registrar.component.html',
  styleUrls: ['./registrar.component.css']
})
export class RegistrarComponent implements OnInit {
  editable1: boolean = false;
  editable2: boolean = false;
  editable3: boolean = false;
  completed1: boolean = false;
  completed2: boolean = false;
  completed3: boolean = false;
  isLinear = false;
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  tresFormGroup: UntypedFormGroup;
  color = 'primary';
  checked = false;
  disabled = false;
  codigo_cliente="";
  estado_apertura=true;


  cargar_info()
  {

    var w = window.open (this.servicio.url_global+"generacion_uso_clave_internet.pdf","winName","location=0,width=600,height=400");
      w.focus();
  }






  constructor(private el: ElementRef,private router:Router,private servicio:Servicio,private _snackBar: MatSnackBar,private ngxService: NgxUiLoaderService,private _formBuilder: UntypedFormBuilder) { }
  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
     return false;
    }
    if (e.which === 0) {
     return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
   }
  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      'numero_tarjeta': ['', Validators.required],
      'pin': ['', Validators.required],
      
      
    });
    this.secondFormGroup = this._formBuilder.group({
     
      'correo_electronico':['',[Validators.email,Validators.required]],
      'permiso':[false,Validators.requiredTrue]
    });
    this.tresFormGroup = this._formBuilder.group({
      'clave_socio_linea': ['',[ Validators.required,Validators.pattern("(?=.*?[0-9])(?=.*?[a-z]).{8,}"),]],
    
      'clave_socio_linea_res':['',[Validators.required,Validators.minLength(6),
        this.matchValues('clave_socio_linea')
      
      ]]
    });
  }
  onChange(value: MatSlideToggleChange) {
   var estado=this.secondFormGroup.value["permiso"];
   if(estado){
       this.estado_apertura=false;
   }else{
    this.estado_apertura=true;

   }
  }
validar_dos(stepper: MatStepper){
    if(!this.secondFormGroup.invalid){
      
        stepper.next(); 
    }
}
validar_tres(){
      if(!this.tresFormGroup.invalid){
         var _this=this;
        this.ngxService.start(); 
           var request={};
           var response={};
           request["informacion"]= this.secondFormGroup.value;
           request["personal"]=this.tresFormGroup.value;
           request["codigo_cliente"]=this.codigo_cliente;
           request["token"]= _this.token;
           this.servicio.enviar_seguro("api/ws_socioenlineainsusuario",JSON.stringify(request),sessionStorage.getItem("token")).pipe().subscribe(
            response=>{
             
                 if(response["status"]==200){
                      if(response["response"][0]["rpt"]!="0"){
                        _this._snackBar.open(response["response"][0]["msg"],"", {
                          panelClass: ["blue1-snackbar"],
                          duration: 2* 1000,
                        
                        });
                        this.ngxService.stop();
                        this.router.navigate(['/inicio']);
                      }else{

                        _this._snackBar.open(response["response"][0]["msg"],"", {
                          panelClass: ["blue-snackbar"],
                          duration: 2* 1000,
                       
                        });
                        this.ngxService.stop();
                      }

                 }else{
                  _this._snackBar.open("ERROR DEL SERVIDOR","", {
                    panelClass: ["blue-snackbar"],
                    duration: 2* 1000,
                 
                  });
                  this.ngxService.stop();
                 }
            },
              error => {
              }
          );
      }
}

token:String="";
  validar_uno(stepper: MatStepper){
    var _this=this;
   if (!this.firstFormGroup.invalid) {
    this.ngxService.start(); 
     var request={};
     request= this.firstFormGroup.value;
     this.servicio.enviar_seguro("api/ws_validartarjeta",request,sessionStorage.getItem("token")).pipe().subscribe(
      response=>{
       var data=response["response"];
       if(data["responseCode"]== "200" ){
         if(data["estado_bloqueado"]==0){
        this.ngxService.stop();
        stepper.next(); 
            _this.codigo_cliente=data["cuenta"];
            _this.token=data["token_sesion"];
         }else{
          Swal.fire(
            'ERROR!',
            "Su tarjeta se bloqueo por seguridad , para sacar otra tarjeta acercase a una de nuestras oficinas",
            'error'
          ).then((result) => {
           
          });

         }
       }
       if(data["responseCode"]== "401"){
   
        this.ngxService.stop();

        if(data["estado_bloqueado"]==1){
          Swal.fire(
            'ERROR!',
            "Su tarjeta se bloqueo por seguridad , para sacar otra tarjeta acercase a una de nuestras oficinas",
            'error'
          ).then((result) => {
           
          });
        }else{
          _this._snackBar.open("El número de tarjeta o clave son incorrectos, por favor vuelva a intentar. Se bloqueará en el quinto intento","", {
            panelClass: ["blue-snackbar"],
            duration: 2* 1000,
          });
        }
      }
      if(data["responseCode"]== "400"){
      
        this.ngxService.stop();

        if(data["estado_bloqueado"]==1){
          Swal.fire(
            'ERROR!',
            "Su tarjeta se bloqueo por seguridad , para sacar otra tarjeta acercase a una de nuestras oficinas",
            'error'
          ).then((result) => {
           
          });
        }else{
          _this._snackBar.open("El número de tarjeta o clave son incorrectos, por favor vuelva a intentar. Se bloqueará en el quinto intento","", {
            panelClass: ["blue-snackbar"],
            duration: 2* 1000,
     
          });
        }
      }
    }  ,
    error => {});
   }
  }

   matchValues(
    matchTo: string 
 ): (AbstractControl) => ValidationErrors | null {
    return (control: AbstractControl): ValidationErrors | null => {
      return !!control.parent &&
        !!control.parent.value &&
        control.value === control.parent.controls[matchTo].value
        ? null
        : { isMatching: false };
    };
}
}
